/**
 * Constant representing the list of filter parameters to exclude from counter calculations.
 *
 * This constant holds an array of parameter names that should not be considered when calculating
 * the count of items based on applied filters. For example, parameters like 'size', 'sort', and
 * 'page' are excluded as they do not directly affect the item count.
 *
 * @const {Array<string>}
 */
export const FILTERS_TO_EXCLUDE_FROM_COUNT: Array<string> = [
	'size',
	'sort',
	'page',
	'preview',
];

/**
 * Enum representing the possible statuses of an agent request.
 *
 * It can be used to manage and track the status of agent requests throughout the application.
 *
 * @enum {string}
 */
export enum AgentRequestStatus {
	ready = 'ready',
	declined = 'declined',
	reSent = 're_sent',
	inProgress = 'in_progress',
	deactivated = 'deactivated'
}

/**
 * Enum representing the possible actions of an agent request.
 *
 * It can be used to manage and track the actions of agent requests throughout the application.
 *
 * @enum {string}
 */
export enum AgentRequestAction {
	ready = 'ready',
	declined = 'declined',
	reSend = 're_send',
	inProgress = 'in_progress',
	deactivated = 'deactivated',
	reactivate = 'reactivate'
}

/**
 * Enum representing the possible bulk actions that can be performed on users.
 *
 * This enum defines two actions: 'DeactivateUser' and 'ActivateUser'. It is used to specify
 * the type of bulk action that can be applied to a group of users within the application.
 *
 * @enum {string}
 */
export enum UserBulkAction {
	deactivateUser = 'DeactivateUser',
	activateUser = 'ActivateUser'
}

/**
 * Enum representing the different types of user sorting options available in the application.
 *
 * This enum defines various sorting criteria that can be applied to a list of users.
 * It also includes options for no sorting and sorting of different user types.
 *
 * @enum {string}
 */
export enum UserSortType {
	none = 'none',
	all = 'all',
	admin = 'admin',
	agent = 'agent',
	talent = 'talent',
	customer = 'customer'
}
